import React, { useState } from 'react';
import './app-shell.css';

const layoutStyles = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;600;700;900&family=Pacifico&display=swap');
    body { font-family: 'Inter', sans-serif; background: #fff1f2; margin: 0; }
    .glass-premium { 
        background: rgba(255, 255, 255, 0.85); 
        backdrop-filter: blur(20px); 
        -webkit-backdrop-filter: blur(20px); 
        border: 1px solid rgba(219, 39, 119, 0.2); 
        box-shadow: 0 40px 60px -15px rgba(0, 0, 0, 0.05); 
    }
    .form-control-premium {
        background: white !important;
        border: 1px solid rgba(219, 39, 119, 0.2) !important;
        border-radius: 15px !important;
        padding: 12px 18px !important;
        transition: all 0.3s ease;
    }
    .form-control-premium:focus {
        border-color: #db2777 !important;
        box-shadow: 0 0 0 4px rgba(219, 39, 119, 0.1) !important;
    }
    .blob { position: fixed; width: 600px; height: 600px; border-radius: 50%; z-index: 0; pointer-events: none; animation: float 30s infinite alternate; }
    .blob-1 { background: radial-gradient(circle, rgba(251,113,133,0.2) 0%, rgba(255,255,255,0) 70%); top: -10%; left: -10%; }
    .blob-2 { background: radial-gradient(circle, rgba(245,158,11,0.15) 0%, rgba(255,255,255,0) 70%); bottom: -10%; right: -10%; animation-delay: -5s; }
    @keyframes float { 0% { transform: translate(0,0) rotate(0deg); } 100% { transform: translate(100px, 100px) rotate(15deg); } }
    .ls-lg { letter-spacing: 0.15em; }
    .fw-900 { font-weight: 900; }
    .magic-heart { font-family: 'Inter', sans-serif; font-weight: 900; letter-spacing: -0.02em; color: #db2777; text-transform: uppercase; }
    .fade-in-up { animation: fadeInUp 0.8s cubic-bezier(0.2, 0.8, 0.2, 1) forwards; opacity: 0; }
    @keyframes fadeInUp { from { opacity: 0; transform: translateY(30px); } to { opacity: 1; transform: translateY(0); } }
    .text-pink-600 { color: #db2777 !important; }
    .hover-scale { transition: transform 0.2s ease, box-shadow 0.2s ease; }
    .hover-scale:hover { transform: translateY(-3px); }
`;

export const Branding = () => (
    <div className="mb-4 text-center">
        <div className="d-inline-flex align-items-center justify-content-center mb-3">
            <img src="https://www.solteros.it/images/logo.svg" alt="Solteros" style={{ width: '120px', height: 'auto' }} />
        </div>
        <h1 className="fw-900 mb-0 magic-heart" style={{ fontSize: '2.2rem' }}>SOLTEROS</h1>
        <p className="text-muted small fw-600 ls-lg text-uppercase mb-0">Speed Date Pro</p>
    </div>
);

export const Copyright = () => (
    <div className="app-shell-foot opacity-60">
        <p className="small mb-1 fw-600 ls-lg text-muted">COPYRIGHT 2026 <a href="https://www.solteros.it" target="_blank" rel="noopener noreferrer" style={{ color: '#db2777', textDecoration: 'none' }}>WWW.SOLTEROS.IT</a></p>
        <p className="small mb-0 text-muted" style={{ fontSize: '0.65rem' }}>Powered by <a href="https://virtualbar.top" target="_blank" rel="noopener noreferrer" style={{ color: '#db2777', textDecoration: 'none' }}>virtualbar.top</a></p>
    </div>
);

/**
 * App shell con hamburger menu (off-canvas drawer).
 *
 * Props:
 *  - children        : contenuto della sezione attiva
 *  - menuItems       : array { key, label, icon, danger } — se presente mostra il pulsante hamburger
 *  - activeKey       : chiave della sezione attiva (evidenziata nel drawer)
 *  - onNavigate      : (key) => void — callback alla selezione di una voce del menu
 *  - user            : { photo, firstName, lastName, email } per l'header del drawer
 *  - unreadCount     : messaggi non letti (badge sulla campanella)
 *  - onBellClick     : callback campanella (se assente la campanella non viene mostrata)
 *  - onBack          : se presente, mostra una freccia "indietro" al posto dell'hamburger
 *  - footer          : contenuto custom del footer (default: <Copyright />)
 */
const Layout = ({ children, menuItems, activeKey, onNavigate, user, unreadCount, onBellClick, onBack, footer }) => {
    const [open, setOpen] = useState(false);
    const hasMenu = Array.isArray(menuItems) && menuItems.length > 0;

    const handleSelect = (key) => {
        setOpen(false);
        if (onNavigate) onNavigate(key);
    };

    return (
        <div className="app-shell">
            <style>{layoutStyles}</style>
            <div className="blob blob-1"></div>
            <div className="blob blob-2"></div>

            {/* Top bar */}
            <header className="app-topbar">
                <div style={{ width: '42px' }}>
                    {onBack ? (
                        <button className="app-topbar-btn" onClick={onBack} aria-label="Indietro">
                            <i className="fas fa-arrow-left"></i>
                        </button>
                    ) : hasMenu ? (
                        <button className="app-topbar-btn" onClick={() => setOpen(true)} aria-label="Apri menu">
                            <i className="fas fa-bars"></i>
                        </button>
                    ) : null}
                </div>

                <div className="app-topbar-brand" onClick={() => hasMenu && handleSelect('home')}>
                    <img src="https://www.solteros.it/images/logo.svg" alt="Solteros" />
                    <span>
                        <span className="brand-name d-block">Solteros</span>
                        <span className="brand-sub">Speed Date</span>
                    </span>
                </div>

                <div style={{ width: '42px', display: 'flex', justifyContent: 'flex-end' }}>
                    {onBellClick && (
                        <button
                            className={`app-topbar-btn position-relative ${unreadCount > 0 ? 'app-topbar-alert' : ''}`}
                            onClick={onBellClick}
                            aria-label={unreadCount > 0 ? 'Messaggi privati non letti' : 'I miei match'}
                        >
                            <i className={`fas ${unreadCount > 0 ? 'fa-bell' : 'fa-heart'}`}></i>
                            {unreadCount > 0 && (
                                <span className="app-bell-badge">{unreadCount}</span>
                            )}
                        </button>
                    )}
                </div>
            </header>

            {/* Content */}
            <main className="app-content">{children}</main>

            {/* Footer */}
            {footer || <Copyright />}

            {/* Hamburger drawer */}
            {hasMenu && open && (
                <>
                    <div className="app-drawer-backdrop" onClick={() => setOpen(false)}></div>
                    <aside className="app-drawer" role="dialog" aria-label="Menu principale">
                        <div className="app-drawer-head">
                            {user ? (
                                <>
                                    <div className="d-flex align-items-center gap-3">
                                        <div className="rounded-circle bg-white shadow-sm overflow-hidden flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '52px', height: '52px', border: '2px solid rgba(255,255,255,0.6)' }}>
                                            {user.photo ? (
                                                <img src={user.photo} alt="Profilo" className="w-100 h-100 object-fit-cover" />
                                            ) : (
                                                <i className="fas fa-user" style={{ color: '#db2777' }}></i>
                                            )}
                                        </div>
                                        <div style={{ minWidth: 0 }}>
                                            <div className="drawer-greeting">Ciao,</div>
                                            <div className="drawer-user text-truncate">{user.firstName || 'Utente'} {user.lastName || ''}</div>
                                            {user.email && <div className="drawer-mail">{user.email}</div>}
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <div className="drawer-user">Solteros</div>
                            )}
                        </div>

                        <div className="app-drawer-body">
                            <div className="app-drawer-label">Naviga</div>
                            {menuItems.map(item => (
                                <button
                                    key={item.key}
                                    className={`app-menu-item ${activeKey === item.key && !item.danger ? 'active' : ''} ${item.danger ? 'danger' : ''}`}
                                    onClick={() => handleSelect(item.key)}
                                >
                                    <span className="menu-icon"><i className={item.icon}></i></span>
                                    <span>{item.label}</span>
                                    {item.badge ? (
                                        <span className="app-menu-badge">{item.badge}</span>
                                    ) : null}
                                </button>
                            ))}
                        </div>

                        <div className="app-drawer-foot">
                            <p className="small mb-0 text-center text-muted fw-600" style={{ fontSize: '0.68rem' }}>
                                <a href="https://www.solteros.it" target="_blank" rel="noopener noreferrer" className="text-decoration-none" style={{ color: '#db2777' }}>www.solteros.it</a>
                            </p>
                        </div>
                    </aside>
                </>
            )}
        </div>
    );
};

export default Layout;
